import React, { Component } from "react";
import uuidv4 from "uuid/v4";
import sanitizeFilename from "sanitize-filename";
import { Tooltip, Icon } from "@material-ui/core/";
import {
  MODEL_FILE_EXT_REGX,
  FILE_SANITATION_REGX,
  MAX_MODEL_FILE_SIZE,
  WHITE_SPACE_RATIO,
  PICTURE_SIZE
} from "./constants";

var Utils = (function () {
  return {
    User: User,
    Project: Project,
    uuidv4: uuidv4,
    sanitizeFilenameExt: sanitizeFilenameExt,
    extractModelExtension: extractModelExtension,
    extractModelFilename: extractModelFilename,
    validateModel: validateModel,
    path: path,
    Validation: Validation,
    base64ArrayBuffer: base64ArrayBuffer,
    googleMarkerPixelSize: googleMarkerPixelSize,
    validateEmail: validateEmail,
    valueArrayToObject: valueArrayToObject
  };

  function valueArrayToObject(array, keyField, valueField) {
    return array.reduce((obj, item) => {
      obj[item[keyField]] = item[valueField];
      return obj;
    }, {});
  }
  function googleMarkerPixelSize(zoom, lat, widthMeters, heightMeters) {

    let maxMeters = Math.max(widthMeters, heightMeters);
    maxMeters = maxMeters < 1 ? maxMeters * 100 : maxMeters; // temporary heurstic for small models
    return pixelSize(zoom, lat, maxMeters) * WHITE_SPACE_RATIO;
  }

  function pixelSize(zoom, lat, sizeMeters) {
    return sizeMeters / metersPerPx(zoom, lat);
  }

  function metersPerPx(zoom, lat) {
    return (156543.03392 * Math.cos((lat * Math.PI) / 180)) / Math.pow(2, zoom);
  }

  function extractModelExtension(input) {
    return input
      .split(".")
      .pop()
      .toLowerCase();
  }
  function extractModelFilename(input) {
    let arr = input.split(".");
    arr.pop();
    return arr.reduce((x, y) => x + "-" + y);
  }

  function validateModel(file) {
    if (!new RegExp(MODEL_FILE_EXT_REGX).test(file.name))
      return new Validation(
        "File type not suported. ",
        "error",
        "Supported file types: fbx, obj, skp, ifc, rvt, 3dm, dxf, dwg, dae"
      );
    if (file.size > MAX_MODEL_FILE_SIZE)
      return new Validation(
        "File size exceeded. Max:" + MAX_MODEL_FILE_SIZE / 1024 / 1024 + "MB",
        "error"
      );
    return new Validation();
  }
  /* type:[note,warning,error] */
  function Validation(message, type, explanation) {
    return {
      type: type || "",
      message: <span>{message}{explanation ? (<Tooltip title={explanation}>
        <span style={{ textDecoration: "underline" }}> More info</span>
      </Tooltip>) : null}</span>,
      invalid: type === "error" ? true : false,
      explanation: explanation
    };
  }

  function User(userId, email) {
    this.userId = userId;
    this.email = email;
    this.projects = [];
  }

  function Project(
    count,
    projectId,
    projectName,
    fileName,
    lat,
    lng,
    rot,
    description,
    email
  ) {
    this.projectId = projectId || uuidv4();
    this.projectKey = (count || "0") + "-" + sanitizeFilenameExt(projectName) + "-" + new Date().toISOString().replace(/-|:|/g, "").substring(0, 15).substring();
    this.projectName = projectName;
    this.originalModelName = extractModelFilename(fileName);
    this.modelName = this.projectKey;
    this.modelExtension = extractModelExtension(fileName);
    this.lat = lat;
    this.lng = lng;
    this.rot = rot;
    this.description = description;
    this.deleted = false;
    this.uploadStart = new Date().toISOString()
    this.email = email || "";
  }

  function sanitizeFilenameExt(filename) {
    return sanitizeFilename(filename.replace(FILE_SANITATION_REGX, ""));
  }

  function path(projectKey, path, extension) {
    let toFile = projectKey !== null ? projectKey + "/" + path : path;
    return extension ? toFile + "." + extension : toFile;
  }
  function validateEmail(value) {
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
      return true;
    }

    return false;
  }

  function base64ArrayBuffer(arrayBuffer) {
    var base64 = "";
    var encodings =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

    var bytes = new Uint8Array(arrayBuffer);
    var byteLength = bytes.byteLength;
    var byteRemainder = byteLength % 3;
    var mainLength = byteLength - byteRemainder;

    var a, b, c, d;
    var chunk;

    // Main loop deals with bytes in chunks of 3
    for (var i = 0; i < mainLength; i = i + 3) {
      // Combine the three bytes into a single integer
      chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];

      // Use bitmasks to extract 6-bit segments from the triplet
      a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
      b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
      c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
      d = chunk & 63; // 63       = 2^6 - 1

      // Convert the raw binary segments to the appropriate ASCII encoding
      base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
    }

    // Deal with the remaining bytes and padding
    if (byteRemainder == 1) {
      chunk = bytes[mainLength];

      a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2

      // Set the 4 least significant bits to zero
      b = (chunk & 3) << 4; // 3   = 2^2 - 1

      base64 += encodings[a] + encodings[b] + "==";
    } else if (byteRemainder == 2) {
      chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];

      a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
      b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4

      // Set the 2 least significant bits to zero
      c = (chunk & 15) << 2; // 15    = 2^4 - 1

      base64 += encodings[a] + encodings[b] + encodings[c] + "=";
    }

    return base64;
  }
})();

export default Utils;
